module.exports = __webpack_public_path__ + "static/media/wide.8d933e52.jpg";